import * as React from 'react';
import { PortalContext } from '../../../../context/portal-context';
import { Environment } from '../../../../enviroment';
import { vwDataRedirect } from '../../../../helpers/VouchersHelper';
import { VouchersCard } from './vouchers-card';
import { NormalizedVoucher, VoucherStatus } from '@esportal/portal-service';
import { useVouchersTracker } from '../hooks/use-vouchers-tracker';

export const VouchersCtr: React.FC<{
	voucher: NormalizedVoucher;
	showButton?: boolean;
	setVouchersPopupData: React.Dispatch<React.SetStateAction<NormalizedVoucher | undefined>>;
	setIsVouchersPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ voucher, showButton = true, setVouchersPopupData, setIsVouchersPopupVisible }) => {
	const { navigationService, userInteractionService } = React.useContext(PortalContext);
	const { trackCardClick } = useVouchersTracker(voucher);

	const shouldDisplayGetButton = (voucher: NormalizedVoucher): boolean => {
		let result = true;

		switch (voucher.status) {
			case VoucherStatus.ENJOYED:
			case VoucherStatus.NO_EXPIRATION:
			case VoucherStatus.TO_ENJOY:
			case VoucherStatus.TO_ENJOY_SOON:
				result = true;
				break;
			case VoucherStatus.EXPIRED:
				result = false;
				break;
		}
		return result;
	};

	const handleClickVoucher = () => {
		trackCardClick();

		if (voucher.source === 'vwData') {
			if (voucher.layer) {
				setVouchersPopupData(voucher);
				setIsVouchersPopupVisible(true);
			} else {
				vwDataRedirect(voucher, navigationService, userInteractionService);
			}
		} else if (voucher.source === 'salesforce') {
			const environmentPath = Environment.getInstance().vouchersDetailPageId as string;
			const search = window.location.search;
			const target = navigationService.navigateTo(environmentPath, {});
			if (target) {
				target.push();
				const href = target.createHref();
				addParamToUrl(href, voucher.id, search);
			} else {
				console.log('detail page not created');
			}
		} else {
			console.error('voucher source error');
		}
	};

	const addParamToUrl = (href: string, param: string, search: string) => {
		const newSearchParams = new URLSearchParams(search);
		newSearchParams.append('voucher-id', param);
		window.history.replaceState(null, '', href + `?${newSearchParams.toString()}`);
	};

	return (
		<VouchersCard
			voucher={voucher}
			shouldDisplayGetButton={shouldDisplayGetButton(voucher)}
			handleClickVoucher={handleClickVoucher}
			showButton={showButton}
		/>
	);
};
